import { useState } from 'react';
import { Box, Checkbox, FormControlLabel, SelectChangeEvent, TextField } from '@mui/material';
import { css } from '@emotion/react';

import { CompositeProfileType } from '../models/CompositeProfileType';
import { CompositeProfileTypeSelect } from '../components/CompositeProfileTypeSelect';
import { IQueueParamProps } from '../../../models/interfaces/IQueueParamProps';

const containerStyle = css({
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    padding: 24,
    gap: 16,
});

export function QueueCompositeProfileParam({ onParamsChange, initialValues }: IQueueParamProps) {
    const values = initialValues ?? {};

    const [type, setType] = useState<CompositeProfileType>(
        values.Type !== undefined ? Number(values.Type) as CompositeProfileType : CompositeProfileType.CompositeProfile
    );
    const [density, setDensity] = useState(values.Density ?? '');
    const [autoPublish, setAutoPublish] = useState(values.AutoPublish?.toLowerCase() === 'true');

    function buildParams(overrides: Record<string, string>): Record<string, string> {
        return {
            Type: String(type),
            Density: density,
            AutoPublish: String(autoPublish),
            ...overrides,
        };
    }

    function handleTypeChange(event: SelectChangeEvent<CompositeProfileType>) {
        const value = event.target.value as CompositeProfileType;
        setType(value);
        onParamsChange?.(buildParams({ Type: String(value) }));
    }

    function handleDensityChange(e: React.ChangeEvent<HTMLInputElement>) {
        const value = e.target.value;
        setDensity(value);
        onParamsChange?.(buildParams({ Density: value }));
    }

    function handleAutoPublishChange(e: React.ChangeEvent<HTMLInputElement>) {
        const value = e.target.checked;
        setAutoPublish(value);
        onParamsChange?.(buildParams({ AutoPublish: String(value) }));
    }

    return (
        <Box css={containerStyle}>
            <CompositeProfileTypeSelect value={type} onChange={handleTypeChange} />
            <TextField
                label='Density'
                type='number'
                value={density}
                onChange={handleDensityChange}
                fullWidth
            />
            <FormControlLabel
                control={<Checkbox checked={autoPublish} onChange={handleAutoPublishChange} />}
                label='Publish'
            />
        </Box>
    );
}
